
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.468 6.978l4.513-4.47.92-.92c.132-.131.132-.35 0-.525l-.964-.964c-.175-.132-.394-.132-.525 0l-5.39 5.433L1.588.1c-.131-.132-.35-.132-.525 0l-.964.964c-.132.175-.132.394 0 .525l5.433 5.39L.1 12.412c-.132.131-.132.35 0 .525l.964.964c.175.132.394.132.525 0l5.434-5.433 4.47 4.513.92.92c.131.132.35.132.525 0l.964-.964c.132-.175.132-.394 0-.525L8.468 6.978z","fill":"#fff"}})])
          )
        }
      }
    